import type { AdvancedSettings } from '@/types/template';

/**
 * Canonical default scheduling rules for a new template. Single source of
 * truth: the blank wizard/Build-workspace state seeds from this, and the Build
 * workspace's "customised rules" badge diffs against it. Keep all default rule
 * values here so the seed and the badge baseline can never drift apart.
 */
export const DEFAULT_ADVANCED_SETTINGS: AdvancedSettings = {
  overrideRestBreak: 11,
  allowSplitShifts: true,
  maxSplitShiftsPerDay: 2,
  minDaysOffPerWeek: 1,
  consecutiveDaysOff: false,
  maxConsecutiveDaysWorked: 6,
};
